import {
  isThisMonth,
  isThisWeek,
  isThisYear,
  isToday,
  isYesterday,
} from "date-fns";
import { getAuth } from "firebase/auth";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";

export default function useTotalRealTimeNotifications() {
  const [AllRealTimeNotifications, setAllRealTimeNotifications] = useState([]);
  const [Type, setType] = useState("all");

  const businessId = getAuth()?.currentUser?.uid;

  useEffect(() => {
    const receiverId = getAuth()?.currentUser?.uid;
    async function fetchData() {
      const notificationsCollection = await collection(db, "notifications");
      let q;
      if (Type === "all") {
        q = query(
          notificationsCollection,
          where("receiver_id", "==", receiverId)
        );
      } else if (Type === "read") {
        q = query(
          notificationsCollection,
          where("receiver_id", "==", receiverId),
          where("is_seen", "==", true)
        );
      } else if (Type === "un-read") {
        q = query(
          notificationsCollection,
          where("receiver_id", "==", receiverId),
          where("is_seen", "==", false)
        );
      }
      await onSnapshot(q, (snapshot) => {
        const RealTimeNotifications = [];
        snapshot.forEach((doc) => {
          RealTimeNotifications.push({ ...doc.data(), id: doc.id });
        });
        setAllRealTimeNotifications(
          RealTimeNotifications && RealTimeNotifications
        );
      });
    }
    fetchData();
  }, [businessId, Type]);

  const [TodayNotifications, setTodayNotifications] = useState([]);
  const [YesterdayNotifications, setYesterdayNotifications] = useState([]);
  const [ThisWeekNotifications, setThisWeekNotifications] = useState([]);
  const [ThisMonthNotifications, setThisMonthNotifications] = useState([]);
  const [ThisYearNotifications, setThisYearNotifications] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const todayNotifications = AllRealTimeNotifications.filter(
        ({ createdAt }) => isToday(new Date(createdAt?.toDate()))
      );
      setTodayNotifications(todayNotifications);

      const yesterdayNotifications = AllRealTimeNotifications.filter(
        ({ createdAt }) => isYesterday(new Date(createdAt?.toDate()))
      );
      setYesterdayNotifications(yesterdayNotifications);

      const thisWeekNotifications = AllRealTimeNotifications.filter(
        ({ createdAt }) => isThisWeek(new Date(createdAt?.toDate()))
      );
      setThisWeekNotifications(thisWeekNotifications);

      const thisMonthNotifications = AllRealTimeNotifications.filter(
        ({ createdAt }) => isThisMonth(new Date(createdAt?.toDate()))
      );
      setThisMonthNotifications(thisMonthNotifications);

      const thisYearNotifications = AllRealTimeNotifications.filter(
        ({ createdAt }) => isThisYear(new Date(createdAt?.toDate()))
      );
      setThisYearNotifications(thisYearNotifications);
    }
    fetchData();
  }, [AllRealTimeNotifications]);

  return [
    AllRealTimeNotifications,
    TodayNotifications,
    setTodayNotifications,
    YesterdayNotifications,
    setYesterdayNotifications,
    setType,
  ];
}
